module.exports = __webpack_public_path__ + "static/media/prize-tray.20527891.png";